<script setup lang="ts">
import ECSPInvestmentProcess from './components/investmentProcess/ecsp/ECSPInvestmentProcess.vue'
import { usePersonalAccountDataState } from './utilities/account/useAccountDataPersonal'
import { useWalletState } from './utilities/account/useWallet'
import NotificationContainer from './components/notification/NotificationContainer.vue'
import { useLegalAccountDataState } from './utilities/account/useAccountDataLegal'
import { isLegalProfile } from './utilities/investment-process/useUserProfileType'
import LoadingSpinner from './components/base/LoadingSpinner.vue'
import { ref } from 'vue'
import { CampaignRegulatoryRequirement, getCampaignData } from './utilities/investment-process/useCampaign'
import DefaultInvestmentProcess from './components/investmentProcess/default/DefaultInvestmentProcess.vue'
import AltFgInvestmentProcess from './components/investmentProcess/altfg/AltFgInvestmentProcess.vue'
import VermAnlGInvestmentProcess from './components/investmentProcess/vermanlg/VermAnlGInvestmentProcess.vue'

const loaded = ref(false)
if (isLegalProfile()) {
    const legalState = useLegalAccountDataState()
    legalState.fetchAccountData().then(() => {
        loaded.value = true
    })
} else {
    const state = usePersonalAccountDataState()
    state.fetchAccountData().then(() => {
        loaded.value = true
    })
}

const walletState = useWalletState()
walletState.fetchWalletData()
</script>

<template>
    <div class="wrapper">
        <NotificationContainer />
        <div v-if="loaded">
            <ECSPInvestmentProcess
                v-if="getCampaignData().asset_data.regulatory_requirements === CampaignRegulatoryRequirement.ECSP" />
            <DefaultInvestmentProcess
                v-else-if="
                    getCampaignData().asset_data.regulatory_requirements === CampaignRegulatoryRequirement.DEFAULT
                " />
            <AltFgInvestmentProcess
                v-else-if="
                    getCampaignData().asset_data.regulatory_requirements === CampaignRegulatoryRequirement.ALTFG
                " />
            <VermAnlGInvestmentProcess
                v-else-if="
                    getCampaignData().asset_data.regulatory_requirements === CampaignRegulatoryRequirement.VERMANLG
                " />
            <div v-else>The Regulatory Requirement is not supported yet. Please contact the support.</div>
        </div>
        <div v-else class="flex h-[65vh] items-center justify-center">
            <LoadingSpinner class="h-10 w-10 fill-primary" />
        </div>
    </div>
</template>
